import { IndividualTaskStatus } from '../IndividualTask';
import { DigestedTaskStatus, DigestType, DigestTypeApi, isValidDigest } from './Digest';
const digestTypeApiToDigestTypeMap = {
  [DigestTypeApi.UNKNOWN_DIGEST_TYPE]: DigestType.UNKNOWN_DIGEST_TYPE,
  [DigestTypeApi.TASK]: DigestType.TASK,
  [DigestTypeApi.TASK_PROGRESS]: DigestType.TASK_PROGRESS,
  [DigestTypeApi.TASK_PLAN]: DigestType.TASK_PLAN,
  [DigestTypeApi.ROUTINE]: DigestType.ROUTINE,
  [DigestTypeApi.CATEGORY]: DigestType.CATEGORY,
  [DigestTypeApi.BRAIN_CONVERSATION]: DigestType.BRAIN_CONVERSATION
};
const digestTaskStatusApiToDigestTaskStatusMap = {
  [IndividualTaskStatus.UNKNOWN]: null,
  [IndividualTaskStatus.ACTION_NEEDED]: DigestedTaskStatus.ACTION_NEEDED,
  [IndividualTaskStatus.COMPLETED]: DigestedTaskStatus.COMPLETED,
  [IndividualTaskStatus.IN_PROGRESS]: DigestedTaskStatus.IN_PROGRESS,
  [IndividualTaskStatus.PENDING]: DigestedTaskStatus.IN_PROGRESS,
  // TODO: should this be a different status?
  [IndividualTaskStatus.PAUSED]: DigestedTaskStatus.PAUSED,
  [IndividualTaskStatus.WAITING]: DigestedTaskStatus.WAITING
};
export const individualTaskStatusApiToDigestTaskStatus = status => {
  if (!status) {
    throw new Error('Individual task status is required');
  }
  const digestTaskStatus = digestTaskStatusApiToDigestTaskStatusMap[status];
  if (!digestTaskStatus) {
    throw new Error(`Unknown individual task status '${status}'`);
  }
  return digestTaskStatus;
};
const digestTypeApiToDigestType = type => {
  if (!type) {
    throw new Error('Digest type is required');
  }
  const digestType = digestTypeApiToDigestTypeMap[type];
  if (!digestType) {
    throw new Error(`Unknown digest type '${type}'`);
  }
  return digestType;
};
export function digestApiToDigestEntity(digestApi) {
  if (!digestApi) {
    throw new Error('digestApi is required');
  }
  const maybeDigest = {
    id: digestApi.id,
    revision: digestApi.revision,
    type: digestTypeApiToDigestType(digestApi.type),
    entityId: digestApi.entityId,
    data: digestApi.data
  };
  if (!isValidDigest(maybeDigest)) {
    throw new Error('Invalid digest API', {
      cause: maybeDigest
    });
  }
  return maybeDigest;
}
//# sourceMappingURL=converters.js.map